interface PageContentProps {
  children: React.ReactNode;
  className?: string;
}

export const PageContent = ({ children, className = '' }: PageContentProps) => (
  <div className={`w-full px-8 py-6 ${className}`.trim()}>
    {children}
  </div>
);
